export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-[72px] overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20cinematic%20film%20reel%20and%20movie%20projector%20in%20a%20dimly%20lit%20theater%20with%20warm%20golden%20accents%2C%20atmospheric%20smoke%2C%20vintage%20cinema%20aesthetic%2C%20rich%20deep%20blacks%20and%20warm%20amber%20highlights%2C%20dramatic%20lighting%2C%20luxurious%20texture%2C%20no%20text&width=1800&height=1200&seq=hero-bg-cinema-01&orientation=landscape"
          alt="五姑娘影院电影主题背景"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-background-50"></div>

      {/* Content */}
      <div className="relative w-full px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          {/* Left text */}
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 text-accent-400 text-xs md:text-sm font-medium mb-5 whitespace-nowrap">
              每日更新 · 不缓冲不卡顿
            </span>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-50 leading-tight mb-4">
              五姑娘影院 · 热门电影<br className="md:hidden" />免费在线观看
            </h1>

            <p className="text-lg md:text-xl text-primary-400 font-heading font-medium mb-6">
              高清大片随时看，精彩不停歇
            </p>

            <p className="text-sm md:text-base text-foreground-400 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              五姑娘影院电影大全致力于为广大影迷打造一站式的免费观影平台。我们每日同步更新最新热门电影、高分动作片及各类经典影片，全站采用高速CDN分发，确保您在任何设备上都能享受不缓冲、不卡顿的高清观影体验。无论您偏爱动作大片、悬疑烧脑还是温情喜剧，都能在这里找到心仪之选。
            </p>

            {/* Stats */}
            <div className="flex flex-wrap justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">50+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">每日更新影片</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">10万+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">精品影片库</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">1080P</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">全高清画质</div>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-400 text-background-950 font-semibold rounded-md text-sm transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                开始观影
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3 bg-background-200/60 hover:bg-background-300/60 text-foreground-200 border border-background-400/40 rounded-md text-sm transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line text-lg"></i>
                热门排行
              </a>
            </div>
          </div>

          {/* Right visual */}
          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-lg overflow-hidden aspect-[4/3] bg-background-200/30 border border-background-300/30">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20golden%20film%20strip%20curving%20through%20a%20dark%20cinematic%20space%20with%20dramatic%20spotlight%2C%20luxurious%20theater%20curtains%20in%20deep%20red%2C%20celluloid%20texture%2C%20warm%20amber%20glow%20on%20dark%20background%2C%20artistic%20composition%2C%20no%20text%20or%20words&width=900&height=675&seq=hero-visual-cinema-02&orientation=landscape"
                alt="五姑娘影院电影主题视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}